import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import SearchBar from "../../components/SearchBar";
import { Box, Button, Tab, Tabs } from "@mui/material";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import OfferTable from "./dinning/offerTable";
import CustomPagination from "../../components/CustomPagination";
import { useLocation, useNavigate } from "react-router-dom";
import { isValidInput } from "../../utils/validations";
import {
  useChangeOfferStatusMutation,
  useLazyExportOffersQuery,
  useLazyGetOffersQuery,
  useTagsByGroupsMutation,
} from "../../service/offer";
import { showError, showToast } from "../../constants/toasts";
import { useLazyGetCategoryQuery } from "../../service/category";
import { Categories, TagGroup } from "../../types/General";
import { removeFromStorage, STORAGE_KEYS } from "../../helpers";
import Loader from "../../constants/Loader";
import OfferFilters from "../../components/OfferFilters";
import { useAppDispatch, useAppSelector } from "../../hooks/store";
import { RootState } from "../../app/store";
import {
  resetOfferFilters,
  setOfferFilters,
} from "../../reducers/offerFiltersSlice";
import { useLazyGetTagGroupsQuery } from "../../service/group&tags";
import dayjs from "dayjs";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

enum STATUS {
  ACTIVE = "active",
  ARCHIVE = "archive",
  EXPIRED = "expired",
  SCHEDULE = "schedule",
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function OfferManagement() {
  const location = useLocation();
  const { state } = location;

  const dispatch = useAppDispatch();
  const offerFilters = useAppSelector((state: RootState) => state.offerFilters);

  const status = state?.status || "";
  const categoryTab = state?.categoryTab || "";
  const categoryId = state?.categoryId || "";

  const [getOffers] = useLazyGetOffersQuery();
  const [getCategory] = useLazyGetCategoryQuery();
  const [offerStatus] = useChangeOfferStatusMutation();
  const [getGroups] = useLazyGetTagGroupsQuery();
  const [tagsByGroups] = useTagsByGroupsMutation();
  const [exportOffers] = useLazyExportOffersQuery();

  const [valueTabs, setValueTabs] = useState(0);
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setPage(1);
    setValueTabs(newValue);
    const categoryId = categoryData?.[newValue]?.id || null;
    setSelectedCategoryId(categoryId);
    const categoryName = categoryData?.[newValue]?.name || "";
    setCategoryName(categoryName);
  };

  const [valueTabs1, setValueTabs1] = React.useState(0);
  const handleChangeTabs1 = (event: React.SyntheticEvent, newValue: number) => {
    setPage(1);
    setValueTabs1(newValue);
  };
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [offerData, setOfferData] = useState([]);
  const [count, setCount] = useState(10);
  const [page, setPage] = useState(1);
  const [categoryData, setCategoryData] = useState<Categories[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(
    ""
  );

  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentSortOrder, setCurrentSortOrder] = useState("DateCreated_desc");
  const [groupData, setGroupData] = useState<TagGroup[]>([]);
  const [tagsData, setTagsData] = useState<TagGroup[]>([]);

  const getOffersApi = async (clearAll?: any) => {
    try {
      setLoading(true);

      const body = {
        ...(offerFilters.startRange && !clearAll
          ? {
              startDate: dayjs(offerFilters.startRange).format(
                "YYYY-MM-DDTHH:mm:ss"
              ),
            }
          : {}),
        ...(offerFilters.endRange && !clearAll
          ? {
              endDate: dayjs(offerFilters.endRange).format(
                "YYYY-MM-DDTHH:mm:ss"
              ),
            }
          : {}),
        ...(offerFilters.isButterflyEffect && !clearAll
          ? { isButterflyEffect: offerFilters.isButterflyEffect }
          : {}),
        ...(offerFilters.isCancellationPolicy && !clearAll
          ? { isCancellationPolicy: offerFilters.isCancellationPolicy }
          : {}),
        ...(offerFilters.tags && !clearAll ? { tags: offerFilters.tags } : {}),
        ...(offerFilters.groups && !clearAll
          ? { groups: offerFilters.groups }
          : {}),
        ...(offerFilters.eventType && !clearAll
          ? { eventType: offerFilters.eventType }
          : {}),
        ...(offerFilters.offerType && !clearAll
          ? { offerType: offerFilters.offerType }
          : {}),
        ...(offerFilters.memberPrice && !clearAll
          ? { memberPrice: offerFilters.memberPrice }
          : {}),
        ...(offerFilters.nonMemberPrice && !clearAll
          ? { nonMemberPrice: offerFilters.nonMemberPrice }
          : {}),
        ...(offerFilters.popularOffer && !clearAll
          ? { popularOffer: offerFilters.popularOffer }
          : {}),
      };

      const response = await getOffers({
        page: page,
        search: debouncedSearchTerm,
        categoryId: selectedCategoryId,
        status:
          valueTabs1 === 0
            ? STATUS.ACTIVE
            : valueTabs1 === 1
              ? STATUS.SCHEDULE
              : valueTabs1 === 2
                ? STATUS.EXPIRED
                : valueTabs1 === 3
                  ? STATUS.ARCHIVE
                  : "",
        sortOrder: currentSortOrder,
        body,
      }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        setOfferData(response?.data?.result1?.items || []);
        setCount(response?.data?.result1?.totalCount);
        setCurrentSortOrder(response?.data?.sortOrder || "");
      } else {
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const exportOfferApi = async (clearAll?: any) => {
    try {
      setLoading(true);
      const body = {
        ...(offerFilters.startDate && !clearAll
          ? { startDate: offerFilters.startDate?.toISOString() }
          : {}),
        ...(offerFilters.endDate && !clearAll
          ? { endDate: offerFilters.endDate?.toISOString() }
          : {}),
        ...(offerFilters.isButterflyEffect && !clearAll
          ? { isButterflyEffect: offerFilters.isButterflyEffect }
          : {}),
        ...(offerFilters.isCancellationPolicy && !clearAll
          ? { isCancellationPolicy: offerFilters.isCancellationPolicy }
          : {}),
        ...(offerFilters.tags && !clearAll ? { tags: offerFilters.tags } : {}),
        ...(offerFilters.groups && !clearAll
          ? { groups: offerFilters.groups }
          : {}),
        ...(offerFilters.eventType && !clearAll
          ? { eventType: offerFilters.eventType }
          : {}),
        ...(offerFilters.offerType && !clearAll
          ? { offerType: offerFilters.offerType }
          : {}),
        ...(offerFilters.memberPrice && !clearAll
          ? { memberPrice: offerFilters.memberPrice }
          : {}),
        ...(offerFilters.nonMemberPrice && !clearAll
          ? { nonMemberPrice: offerFilters.nonMemberPrice }
          : {}),
        ...(offerFilters.popularOffer && !clearAll
          ? { popularOffer: offerFilters.popularOffer }
          : {}),
      };

      const response: any = await exportOffers({
        search: debouncedSearchTerm,
        categoryId: selectedCategoryId,
        status:
          valueTabs1 === 0
            ? STATUS.ACTIVE
            : valueTabs1 === 1
              ? STATUS.SCHEDULE
              : valueTabs1 === 2
                ? STATUS.EXPIRED
                : valueTabs1 === 3
                  ? STATUS.ARCHIVE
                  : "",
        body,
        format: "excel",
      }).unwrap();
      setLoading(false);
      if (response.statusCode === 200) {
        window.open(response?.downloadUrl, "_blank");
      } else {
        setLoading(false);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const getCategoryApi = async () => {
    try {
      setLoading(true);
      const response = await getCategory({ search: "" }).unwrap();
      setLoading(false);
      if (response.status === 200) {
        const activeCategory = response?.data?.filter(
          (item: any) => item?.isActive === true
        );
        setCategoryData(activeCategory || []);
        // setCount(response?.data?.totalCount);
        if (categoryId) {
          setSelectedCategoryId(categoryId);
          setCategoryName(state?.categoryName);
        } else {
          setSelectedCategoryId(activeCategory?.[0]?.id);
          setCategoryName(activeCategory?.[0]?.name);
        }
      } else {
        setLoading(false);
        setCategoryData([]);
      }
    } catch (error: any) {
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  const changeOfferStatusApi = async (id: string) => {
    try {
      const response = await offerStatus({ offerId: id }).unwrap();
      if (response.status === 200) {
        getOffersApi();
        showToast(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const handleFilterChange = (key: string, value: any) => {
    dispatch(setOfferFilters({ [key]: value }));
  };

  const handleClearAll = () => {
    dispatch(resetOfferFilters());
  };

  const getGroupApi = async () => {
    try {
      const response = await getGroups({
        page: 1,
        search: "",
      }).unwrap();
      if (response.status === 200) {
        setGroupData(response?.data?.items || []);
        // setCount(response?.data?.totalCount);
      } else {
        setGroupData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  const tagsByGroupsApi = async () => {
    const body = {
      GroupId: offerFilters?.selectedGroupsId,
    };

    try {
      const response = await tagsByGroups(body).unwrap();
      if (response.status === 200) {
        setTagsData(response?.data || []);
        // setCount(response?.data?.totalCount);
      } else {
        setTagsData([]);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getCategoryApi();
    if (status) {
      setValueTabs1(status);
    }
    if (categoryTab) {
      setValueTabs(categoryTab);
    }
  }, []);

  useEffect(() => {
    if (selectedCategoryId && currentSortOrder) {
      getOffersApi();
    }
  }, [
    selectedCategoryId,
    page,
    debouncedSearchTerm,
    valueTabs1,
    currentSortOrder,
  ]);

  useEffect(() => {
    getGroupApi();
  }, []);

  useEffect(() => {
    if (offerFilters?.groups?.length) {
      tagsByGroupsApi();
    }
  }, [offerFilters?.groups]);

  return (
    <>
      <MainContainer>
        <Loader isLoad={loading} />
        <div className="main_title d_flex">
          <div className="left_s">
            <h1>Offer Management</h1>
          </div>
          <div className="right_s">
            <SearchBar
              searchTerm={searchTerm}
              placeholder="Search...."
              setDebouncedSearchTerm={setDebouncedSearchTerm}
              value={searchTerm}
              onCross={() => setSearchTerm("")}
              onChange={(val: any) => {
                if (isValidInput(val.target.value)) {
                  setSearchTerm(val.target.value);
                }
              }}
            />
            <Button
              className="btn btn_primary"
              onClick={() => exportOfferApi()}
            >
              <img src="/static/images/export_icon.svg" alt="icon" /> Export
              Data
            </Button>
            <Button
              className="btn btn_primary"
              onClick={() => {
                removeFromStorage(STORAGE_KEYS.offerData);
                removeFromStorage(STORAGE_KEYS.offerImages);
                navigate("/manage-offer/build-offer", {
                  state: {
                    categoryId: selectedCategoryId,
                    categoryName: categoryName,
                    status: valueTabs1,
                    categoryTab: valueTabs,
                    type:
                      valueTabs === 1
                        ? "EVENT"
                        : valueTabs === 2
                          ? "EXPERIENCE"
                          : valueTabs === 6
                            ? "OTHERS"
                            : "RESTAURANT", // fallback
                  },
                });
              }}
            >
              <ControlPointIcon /> Build Offer
            </Button>
            <OfferFilters
              startDate={offerFilters.startRange}
              endDate={offerFilters.endRange}
              setStartDate={(date) => handleFilterChange("startRange", date)}
              setEndDate={(date) => handleFilterChange("endRange", date)}
              eventType={offerFilters.eventType}
              setEventType={(value) => handleFilterChange("eventType", value)}
              offerType={offerFilters.offerType}
              setOfferType={(value) => handleFilterChange("offerType", value)}
              nonMemberPrice={offerFilters.nonMemberPrice}
              setNonMemberPrice={(value) =>
                handleFilterChange("nonMemberPrice", value)
              }
              memberPrice={offerFilters.memberPrice}
              setMemberPrice={(value) =>
                handleFilterChange("memberPrice", value)
              }
              isButterflyEffect={offerFilters.isButterflyEffect}
              setIsButterflyEffect={(value) =>
                handleFilterChange("isButterflyEffect", value)
              }
              isCancellationPolicy={offerFilters.isCancellationPolicy}
              setIsCancellationPolicy={(value) =>
                handleFilterChange("isCancellationPolicy", value)
              }
              popularOffer={offerFilters.popularOffer}
              setPopularOffer={(value) =>
                handleFilterChange("popularOffer", value)
              }
              tags={tagsData}
              selectedTags={offerFilters.tags}
              setSelectedTags={(value) => handleFilterChange("tags", value)}
              groups={groupData}
              selectedGroups={offerFilters.groups}
              setSelectedGroups={(value) => handleFilterChange("groups", value)}
              selectedTagsId={offerFilters.selectedTagsId}
              setSelectedTagsId={(value) =>
                handleFilterChange("selectedTagsId", value)
              }
              selectedGroupsId={offerFilters.selectedGroupsId}
              setSelectedGroupsId={(value) =>
                handleFilterChange("selectedGroupsId", value)
              }
              handleSubmit={getOffersApi}
              handleClearFilters={handleClearAll}
            />
          </div>
        </div>

        <Box
          className="custom_tabs2 offer_manage_tab mt_40 mb_30"
          sx={{ width: "100%" }}
        >
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            {categoryData?.map((item, i) => {
              return <Tab key={i} label={item?.name} {...a11yProps(i)} />;
            })}
          </Tabs>
        </Box>

        {categoryData?.map((_, index) => (
          <CustomTabPanel key={index} value={valueTabs} index={index}>
            <div className="cards table_cards v2">
              <Box className="custom_tabs" sx={{ width: "100%" }}>
                <Tabs
                  value={valueTabs1}
                  onChange={handleChangeTabs1}
                  aria-label="basic tabs example"
                  className="custom_tabs_links"
                >
                  <Tab label="Active" {...a11yProps(0)} />
                  <Tab label="Scheduled" {...a11yProps(1)} />
                  <Tab label="Expired" {...a11yProps(2)} />
                  <Tab label="Archived " {...a11yProps(3)} />
                </Tabs>
              </Box>

              <CustomTabPanel value={valueTabs1} index={0}>
                <OfferTable
                  actionType="active"
                  offerType="dining"
                  offerData={offerData}
                  valueTabs1={valueTabs1}
                  valueTabs={valueTabs}
                  categoryId={selectedCategoryId}
                  categoryName={categoryName}
                  changeOfferStatusApi={changeOfferStatusApi}
                  sortOrder={currentSortOrder}
                  setCurrentSortOrder={setCurrentSortOrder}
                />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs1} index={1}>
                <OfferTable
                  actionType="scheduled"
                  offerType="dining"
                  offerData={offerData}
                  valueTabs1={valueTabs1}
                  valueTabs={valueTabs}
                  categoryId={selectedCategoryId}
                  categoryName={categoryName}
                  changeOfferStatusApi={changeOfferStatusApi}
                  sortOrder={currentSortOrder}
                  setCurrentSortOrder={setCurrentSortOrder}
                />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs1} index={2}>
                <OfferTable
                  actionType="expired"
                  offerType="dining"
                  offerData={offerData}
                  valueTabs1={valueTabs1}
                  valueTabs={valueTabs}
                  categoryId={selectedCategoryId}
                  categoryName={categoryName}
                  changeOfferStatusApi={changeOfferStatusApi}
                  sortOrder={currentSortOrder}
                  setCurrentSortOrder={setCurrentSortOrder}
                />
              </CustomTabPanel>
              <CustomTabPanel value={valueTabs1} index={3}>
                <OfferTable
                  actionType="archived"
                  offerType="dining"
                  offerData={offerData}
                  valueTabs1={valueTabs1}
                  valueTabs={valueTabs}
                  categoryId={selectedCategoryId}
                  categoryName={categoryName}
                  changeOfferStatusApi={changeOfferStatusApi}
                  sortOrder={currentSortOrder}
                  setCurrentSortOrder={setCurrentSortOrder}
                />
              </CustomTabPanel>
            </div>
            <CustomPagination
              currentPage={page - 1}
              totalPages={Math.ceil(count / 10)}
              count={count}
              pageSize={10}
              onPageChange={(page) => setPage(page + 1)}
            />
          </CustomTabPanel>
        ))}
      </MainContainer>
    </>
  );
}

export default OfferManagement;
